import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import c from '../../styles/auth.module.css';
import logoDark from '../../assets/images/icon-only-bronze.png';

// Email/username + password login form. `login` returns { status, message }.
export function LoginForm({ login }) {
  const navigate = useNavigate();
  const [form, setForm]       = useState({ login: '', password: '' });
  const [error, setError]     = useState('');
  const [notice, setNotice]   = useState('');
  const [isLoading, setLoading] = useState(false);

  // Show a notice when redirected here by an expired/invalid session.
  useEffect(() => {
    if (sessionStorage.getItem('sessionExpired')) {
      setNotice('Your session has expired. Please log in again.');
      sessionStorage.removeItem('sessionExpired');
    }
  }, []);

  const update = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setNotice('');
    if (!form.login || !form.password) {
      setError('Missing required fields');
      return;
    }
    setLoading(true);
    const result = await login(form);
    if (result.status === 'success') {
      navigate('/dashboard');
    } else {
      setLoading(false);
      setError(result.message || 'Login Failed');
    }
  };

  return (
    <form className={c.card} onSubmit={onSubmit}>
      <div className={c.logo}>
        <img className={c.logoImg} src={logoDark} alt="ACE CAR SPA" />
      </div>
      <div className={c.title}>Welcome back</div>

      {notice && <div className={c.notice}>{notice}</div>}
      {error && <div className={c.error}>{error}</div>}

      <div className={c.field}>
        <label className={c.label} htmlFor="login">Email / Username</label>
        <input id="login" className={c.input} type="text" autoComplete="username"
          placeholder="you@example.com / username" value={form.login} onChange={update('login')} />
      </div>

      <div className={c.field}>
        <label className={c.label} htmlFor="password">Password</label>
        <input id="password" className={c.input} type="password" autoComplete="current-password"
          placeholder="••••••••" value={form.password} onChange={update('password')} />
      </div>

      <button className={c.button} type="submit" disabled={isLoading}>
        {isLoading ? 'Signing in…' : 'Login'}
      </button>
    </form>
  );
}
